import type { CustomerJobMetadataPolicy } from '~/lib/customer-job-metadata';
import { MpiPhotosType } from '~/tenants/mpi/performable/photos/MpiPhotosConfig';

/**
 * MPI: which fields of each service a customer's post may set (lib/customer-
 * job-metadata.ts), by service id. Every field of every service's schema is
 * listed once, customer or office (customer-job-metadata.test.ts).
 */
export const MPI_CUSTOMER_JOB_METADATA: Record<string, CustomerJobMetadataPolicy> = {
  // MpiPhotosForm: the customer's photos are Standard (Request Reshoot fixes its own type); the count
  // shot, the editor's notes (submit) and the hours of a Commercial order (office-only) are not the
  // customer's; no form sets `photos`.
  photos: {
    customer: [
      'type',
      'extra_photos_max',
      'instructions',
      'detail',
      'detail_notes',
      'community',
      'community_notes',
      'twilight_type',
      'twilight_photos',
    ],
    office: ['extra_photos_actual', 'editor_notes', 'hours', 'photos'],
    officeValues: { type: Object.values(MpiPhotosType).filter((type) => type !== MpiPhotosType.STANDARD) },
  },
  // the editor's notes are written on submit.
  aerial: { customer: ['type'], office: ['editor_notes'] },
  '3d': { customer: ['type'], office: [] },
  floorplan: { customer: [], office: [] },
  staging: { customer: ['photos'], office: [] },
  // no form sets the delivery address.
  flyer: { customer: ['quantity', 'shipping'], office: ['delivery'] },
  // no form sets the delivery address.
  brochures: { customer: ['option', 'quantity', 'shipping'], office: ['delivery'] },
  // MpiHeadshotForm shows neither.
  headshot: { customer: ['people', 'type', 'parking'], office: ['group', 'notes'] },
  virtual: { customer: ['sky', 'photos'], office: [] },
  walkthrough: { customer: ['agent'], office: [] },
  tour: { customer: [], office: [] },
  // the office's own service (hidden from every customer): every field is the office's.
  custom: { customer: [], office: ['description', 'rate', 'pay', 'onsite', 'taxable'] },
};
